const DEFAULT_CHAT_MESSAGE_MAX_CHARS = 20000

function parseLimit(raw: unknown): number {
  const value = Number.parseInt(String(raw || ''), 10)
  if (!Number.isFinite(value)) return DEFAULT_CHAT_MESSAGE_MAX_CHARS
  return Math.min(Math.max(value, 1000), 200000)
}

export const CHAT_MESSAGE_MAX_CHARS = parseLimit(import.meta.env.VITE_CHAT_MESSAGE_MAX_CHARS)

export function buildMessageTooLongError(maxChars = CHAT_MESSAGE_MAX_CHARS): string {
  return `Сообщение слишком длинное. Максимум ${maxChars} символов. Разбейте запрос на части или загрузите файл.`
}
